export default {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'information',
}
